/* eslint-disable @typescript-eslint/no-empty-interface */
import { createTheme } from '@mui/material/styles';

import skappaColours from '@ingka/variables/colours-css';

export const defaultFontFamily = [
  'Noto IKEA',
  'Noto Sans',
  'Roboto',
  'Open Sans',
  'sans-serif',
].join(',');

const {
  colourStaticIkeaBrandBlue,
  colourStaticIkeaBrandYellow,
  colourSemanticNegative,
  colourSemanticPositive,
  colourSemanticCaution,
  colourSemanticInformative,
  colourTextAndIcon1,
  colourTextAndIcon2,
  colourTextAndIcon3,
  colourNeutral2,
  colourNeutral3,
  colourNeutral4,
  colourNeutral5,
  colourNeutral6,
  colourNeutral7,
} = skappaColours;

const theme = createTheme({
  palette: {
    primary: { main: colourStaticIkeaBrandBlue },
    secondary: {
      main: colourStaticIkeaBrandYellow,
    },
    success: { main: colourSemanticPositive },
    warning: { main: colourSemanticCaution },
    error: { main: colourSemanticNegative },
    info: { main: colourSemanticInformative },
    text: {
      primary: colourTextAndIcon1,
      secondary: colourTextAndIcon2,
      disabled: colourTextAndIcon3,
    },
    grey: {
      100: colourNeutral2,
      200: colourNeutral3,
      300: colourNeutral4,
      500: colourNeutral5,
      700: colourNeutral6,
      900: colourNeutral7,
    },
  },
  shape: {},
  typography: {
    fontFamily: defaultFontFamily,
  },
});

export default theme;
